import { render, staticRenderFns } from "./reporterList.vue?vue&type=template&id=705089fd&scoped=true&"
import script from "./reporterList.vue?vue&type=script&lang=js&"
export * from "./reporterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705089fd",
  null
  
)

export default component.exports